import { useEffect } from "react";

export default function GTranslate() {
  useEffect(() => {
    if (document.getElementById("gtranslate-widget-script")) return;

    window.gtranslateSettings = {
      default_language: "en",
      languages: ["en", "es", "fr", "de", "pl", "pt", "ru"],
      wrapper_selector: ".gtranslate_wrapper",
    };

    const script = document.createElement("script");
    script.id = "gtranslate-widget-script";
    script.src = "https://cdn.gtranslate.net/widgets/latest/dropdown.js";
    script.defer = true;

    document.body.appendChild(script);
  }, []);

  return <div className="gtranslate_wrapper" />;
}
